// Data-visualisation colours shared by dashboard charts, legends and default feature styling.

/** Risk ramp: worst to best. Also used for Required / Recommended / Optional. */
const RISK = { high: '#ed2938', medium: '#ffaa1c', low: '#41c300' } as const;

export const identifyColours = [
	{ key: 'Class 1', color: RISK.high },
	{ key: 'Class 2', color: RISK.medium },
	{ key: 'Class 3', color: RISK.low }
];

export const prioritizeColours = [
	{ key: 'Priority 1', color: '#000000' },
	{ key: 'Priority 2', color: RISK.high },
	{ key: 'Priority 3', color: RISK.medium },
	{ key: 'Priority 4', color: '#ffe733' },
	{ key: 'Priority 5', color: RISK.low }
];

export const interventionsColours = [
	{ key: 'Required', color: RISK.high },
	{ key: 'Recommended', color: RISK.medium },
	{ key: 'Optional', color: RISK.low }
];

/** Barrier score bands: monitor, review, recommended, priority. */
export const barrierScoreColours = ['#9a9c9c', RISK.low, RISK.medium, RISK.high];

/** Four-step ramp for continuous MIRE attributes, worst to best. */
export const mireRamp = [RISK.high, '#ff8a1c', '#ffcf33', RISK.low];

/** GIS Services preview: unstyled layers drawn in a colour no basemap uses. */
export const PREVIEW_FEATURE_COLOR = '#eb22e7';

/** Programs maps: selected-corridor halo, and the green start / red end route badges. */
export const PROGRAMS_SELECTION_COLOR = '#1e6fe0';
export const ROUTE_START_COLOR = '#188038';
export const ROUTE_END_COLOR = '#b4193c';

/** Feature colour when a layer has no styling of its own. */
export const DEFAULT_FEATURE_COLOR = '#03a9f4';

/** Legend patch colour when a layer's colour can't be resolved; a literal, as canvas export can't read CSS. */
export const PATCH_FALLBACK = '#d9dbdc';
